import React from 'react';
import { connect } from 'react-redux';
import ReactLink from '@client/components/reactLink/ReactLink';
import Image from '@client/components/image/Image';
import NinetyAccountImage from '@client/shared/images/ninety-account-image.svg';
import { FacebookWhiteCircleSvg } from '@client/components/icons/social/whiteCircle/FacebookWhiteCircleSvg';
import { InstagramWhiteCircleSvg } from '@client/components/icons/social/whiteCircle/InstagramWhiteCircleSvg';
import { LinkedInWhiteCircleSvg } from '@client/components/icons/social/whiteCircle/LinkedInWhiteCircleSvg';
import { YoutubeWhiteCircleSvg } from '@client/components/icons/social/whiteCircle/YoutubeWhiteCircleSvg';
import styles from './mainFooter.scss';

class MainFooter extends React.Component {
  render() {
    return (
      <div className={styles.footerContainer}>
        <div className={styles.footerContent}>
          <div className={styles.footerSectionItem}>
            <h2 className="h2">INSAMLINGSKONTO</h2>
            <ul>
              <li>
                <p className="p">Plusgiro 90 91 92-7</p>
              </li>
              <li>
                <p className="p">Bankgiro 909-1927</p>
              </li>
              <li>
                <p className="p">Swish 90 91 92 7</p>
              </li>
            </ul>
            <div className={styles.ninetyAccountImage}>
              <Image src={NinetyAccountImage} />
            </div>
          </div>
          <div className={styles.footerSectionItem}>
            <h2 className="h2">GÅVOSERVICE</h2>
            <ul>
              <li>
                <p className="p">
                  Telefon: <a href="tel:0200882400">0200-88 24 00</a>
                </p>
              </li>
              <li>
                <p className="p">E-post: </p>
              </li>
              <li>
                <p className="p">
                  <a href="mailto:gava@hjart-lungfonden.se">
                    gava@hjart-lungfonden.se
                  </a>
                </p>
              </li>
            </ul>
            <h2 className="h2">KANSLI</h2>
            <ul>
              <li>
                <p className="p">Hjärt-Lungfonden</p>
              </li>
              <li>
                <p className="p">Box 2167</p>
              </li>
              <li>
                <p className="p">103 14 Stockholm</p>
              </li>
              <li>
                <p className="p">
                  Telefon: <a href="tel:0856624200">08-566 24 200</a>
                </p>
              </li>
              <li>
                <p className="p">E-post: </p>
              </li>
              <li>
                <p className="p">
                  {' '}
                  <a href="mailto:info@hjart-lungfonden.se">
                    info@hjart-lungfonden.se
                  </a>
                </p>
              </li>
              <li>
                <p className="p">Organisationsnummer: 802006-0763</p>
              </li>
            </ul>
            <p className="p"></p>
          </div>
          <div className={styles.footerSectionItem}>
            <h2 className="h2">SJUKDOMAR</h2>
            <ul>
              <li>
                <a href="https://www.hjart-lungfonden.se/sjukdomar/hjartsjukdomar/hjartinfarkt/">
                  Hjärtinfarkt
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/sjukdomar/hjartsjukdomar/hjartrytmrubbningar/">
                  Hjärtrytmrubbningar
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/sjukdomar/lungsjukdomar/kol/">
                  KOL
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/sjukdomar/hjartsjukdomar/karlkramp/">
                  Kärlkramp
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/sjukdomar/hjartsjukdomar/stroke/">
                  Stroke
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/sjukdomar/">
                  Övriga sjukdomar
                </a>
              </li>
            </ul>
            <p className="p"></p>
          </div>
          <div className={styles.footerSectionItem}>
            <h2>FÖLJ OSS</h2>
            <ul className={styles.followUsList}>
              <li className={styles.followUsListItem}>
                <a
                  href="https://www.facebook.com/hjartlungfonden"
                  aria-label="Följ oss på Facebook"
                >
                  <FacebookWhiteCircleSvg />
                </a>
              </li>
              <li className={styles.followUsListItem}>
                <a
                  href="https://www.instagram.com/hjartlungfonden/"
                  aria-label="Följ oss på Instagram"
                >
                  <InstagramWhiteCircleSvg />
                </a>
              </li>
              <li className={styles.followUsListItem}>
                <a
                  href="https://www.youtube.com/user/Hjartlungfonden"
                  aria-label="Följ oss på Youtube"
                >
                  <YoutubeWhiteCircleSvg />
                </a>
              </li>
              <li className={styles.followUsListItem}>
                <a
                  href="https://www.linkedin.com/company/hj-rt-lungfonden/mycompany/"
                  aria-label="Följ oss på Linkedin"
                >
                  <LinkedInWhiteCircleSvg />
                </a>
              </li>
            </ul>
            <ul>
              <li>
                <a href="https://www.hjart-lungfonden.se/om-oss/bestall-material/">
                  Beställ material
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/forskning/effektrapporten/">
                  Effektrapport
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/om-oss/press/">
                  Press
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/om-oss/in-english/">
                  About us
                </a>
              </li>
              <li>
                <a href="https://www.hjart-lungfonden.se/om-oss/dataskydd/">
                  Dataskyddspolicy
                </a>
              </li>
              <li>
                <ReactLink to={'/om-cookies'}>Om cookies</ReactLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(MainFooter);
